////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
/////////ASSETS/////////
import SortableTable from '../../../../../assets/icones/table/sort_table.svg'
import SortableTableNested from '../../../../../assets/icones/table/sort_table_nested.svg'

/////////STYLED/////////
const SortableImageWrapper = styled.img`
	margin-left: 12px;
	max-height: 12px;
	max-width: 6px;
`
/////////STYLED/////////

const SortableImage = (props) => <SortableImageWrapper src={props.nestedTheme ? SortableTableNested : SortableTable} />

SortableImage.propTypes = {}
SortableImage.defaultPropTypes = {}

export default SortableImage
